// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ClientDateAggregationType, DateRangeFilter } from '../../models/date-range-filter';
import { DateAggregationService } from '@coa/app/core/services/date-aggregation/date-aggregation.service';
import { Observable } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'coa-select-date-range-filter',
  templateUrl: './select-date-range-filter.component.html',
  styleUrls: ['./select-date-range-filter.component.scss'],
})
export class SelectDateRangeFilterComponent implements OnChanges {
  @Input() clientId: string;
  @Input() dateRange: DateRangeFilter;
  @Output() filterUpdated = new EventEmitter<DateRangeFilter>();

  dateRangeType = DateRangeFilter;
  clientDateAggregationType = ClientDateAggregationType;
  dateAggregationType: Observable<ClientDateAggregationType>;

  constructor(
    private dateAggregationService: DateAggregationService,
  ) {
  }

  ngOnChanges(): void {
    this.dateAggregationType = this.dateAggregationService.getAggregationTypes(this.clientId);
  }

  updated(matSelectChange: MatSelectChange): void {
    this.filterUpdated.emit(matSelectChange.value);
  }
}
